import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DownloadIcon from '../../../../assests/download.png'
import DeleteIcon from '../../../../assests/delete.png';
import classes from './SingleLessonAssessment.module.css'
import Moment from 'moment';
import { submissionsApi } from "../../../../../../utils";
import Project from "../../../../UI/Project";
import { throwApiError } from "../../../../store/error-handling-actions";
import { DynamicFileThumbnail } from '../../../../functions/DynamicFileThumbnail'
import StatusInfo from "../../../../StatusInfo/StatusInfo";
import SubmitBtn from "../../../../SubmitBtn/SubmitBtn";
import { AttachmentTypeEnumText } from "../../../../models/AttachmentTypeEnum";
import DynamicMessage from "../../../../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from '../../../../models/DynamicMessageTypeEnum';
import FilesPopup from "../../../../UI/Popups/FilesPopup/FilesPopup";
import { ActivityTypeEnum } from "../../../../models/ActivityTypeEnum";
import { changeActiveLessonId } from "../../../../../../store/general-actions";
import { SubmissionStateTypeTextEnum } from "../../../../models/SubmissionStateTypeEnum";


const SingleLessonAssessment = ({
    nameLesson,
    lessonParticipant,
    assessment,
    setAssesmentStatus,
    setSubmissionProject,
    openProject,
    ProjectsComm,
    studyGroupId,
    teacherMode,
    saveProjectCallback,
    shareBtn,
    onlyView,
    setShowReflection,
    setPopupAssessmentLesson,
    isDisabled,
    updateAttachments,
    lessonId }) => {

    const [showDrafts, setShowDrafts] = useState(false)
    const [msg, setMsg] = useState(null);
    const [filesPopup, setFilesPopup] = useState()
    const texts = useSelector(state => state.translate.texts);
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch()

    let contentData = null;
    try {
        contentData = JSON.parse(assessment?.contentData);
    }
    catch { }

    useEffect(() => {
        if (!assessment) { return }
        if (!assessment.submission) {
            const submissionAddInput = {
                assessmentId: assessment.id,
                submissionStatus: SubmissionStateTypeTextEnum.Started,
                studyGroupId: studyGroupId,
            }
            const allUserIds = lessonParticipant?.user?.users?.map(u => u.id !== user.id ? u.id : null).filter(Boolean);
            dispatch(changeActiveLessonId(lessonId, studyGroupId, nameLesson, "allUserIds"));

            submissionsApi.submissionsAddPost({ submissionAddInput }, (submissionsError, submissionsResdata, submissionsResponse) => {
                if (!submissionsError) {
                    setPopupAssessmentLesson({ ...assessment, ...submissionsResdata })
                }
            })
        }
    }, [assessment])

    const forceDownload = (blob, filename) => {
        var a = document.createElement('a');
        a.download = filename;
        a.href = blob;
        // For Firefox https://stackoverflow.com/a/32226068
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    // Current blob size limit is around 500MB for browsers
    const downloadResource = (url, filename) => {
        if (!filename) filename = url.split('\\').pop().split('/').pop();

        fetch(`${assessment.filesBaseUrl}/${url}`, {
            headers: new Headers({
                'Origin': window.location.origin
            }),
            mode: 'cors'
        })
            .then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                forceDownload(blobUrl, filename);
            })
            .catch(e => console.error(e));
    }

    function closePopup(e) {
        e.stopPropagation()
        setShowDrafts(false)
    }

    function changeChosenProject(project) {
        const data = {
            id: assessment.submission?.id,
            projectId: project.id,
            studyGroupId: studyGroupId,
            lessonId: lessonId
        }
        submissionsApi.submissionsExchangeProjectPost({ submissionExchangeProjectInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentSubmissionsChangeStatus, error: error, statusCode: response?.statusCode, message: "submissionsExchangeProjectPost " + error.message, level: 1, component: "SingleLessonAssessment", line: 68 }))
            } else {
                setShowDrafts(false)
                setSubmissionProject(project)
            }
        })
    }

    const chooseFromDevice = (e) => {
        if (e.target.files) {
            // alert msg for big file;
            if (((e.target.files[0].size / 1024) / 1024) > 2) {
                setMsg(<DynamicMessage
                    type={DynamicMessageTypeEnum.Error}
                    title={texts.notAlowedUploadThisFile}
                    content={texts.fileSizeNotSupport}
                    confirmFunc={() => setMsg(null)} />)
            }
            else {
                const data = {
                    id: assessment.submission?.id,
                    fileDescription: e.target.files[0].name,
                    file: e.target.files[0],
                    attachmentType: AttachmentTypeEnumText.File,
                    studyGroupId: studyGroupId
                }
                submissionsApi.submissionsAddFilePost(data, (error, resdata, response) => {
                    if (error) {
                        if (error?.response?.body?.code == 413) {
                            setMsg(<DynamicMessage
                                type={DynamicMessageTypeEnum.Warn}
                                title={texts.LessonInEditByTeamMemberSaveCopy}
                                showCancel={false}
                                confirmText={texts.ok}
                                confirmFunc={() => setMsg(null)} />);
                        }
                        else
                            dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "submissionsAddFilePost " + error.message, level: 1, component: "SingleLessonAssessment", line: 97 }))
                    }
                    else {
                        updateAttachments(resdata);
                    }
                })
            }
        }
    }

    const DeleteFile = (f) => {
        const data = {
            id: assessment.submission?.id,
            fileId: f.Id,
            studyGroupId: studyGroupId
        }
        submissionsApi.submissionsDeleteFilePost({ deleteFileInput: data }, (error, resdata, response) => {
            if (error) {
                if (error?.response?.body?.code == 413) {
                    setMsg(<DynamicMessage
                        type={DynamicMessageTypeEnum.Warn}
                        title={texts.LessonInEditByTeamMemberSaveCopy}
                        showCancel={false}
                        confirmText={texts.ok}
                        confirmFunc={() => setMsg(null)} />);
                }
                else
                    dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "submissionsDeleteFilePost " + error.message, level: 1, component: "SingleLessonAssessment", line: 113 }))
            }
            else {
                updateAttachments(resdata);
            }
        })
    }

    return (
        <div className={classes.SingleLessonAssessment}>
            {msg}
            {assessment ?
                <div className={classes.AssessmentContainer}>
                    <div className={classes.Header}>

                        <div className={classes.StatusBarTextContainer}>
                            <div className={classes.DetailContainer}>
                                <div className={classes.LessonDetails}>
                                    <p className={classes.LessonText}>{texts.lesson}</p>
                                    <p className={classes.LessonName}>{nameLesson}</p>
                                </div>

                                {ActivityTypeEnum[assessment.activityType] === ActivityTypeEnum.Learning &&
                                    <div className={classes.LessonDetails}>
                                        <p className={classes.LessonText}>{texts.successSubmissionAssesment}</p>
                                        <p className={classes.LessonName}>{texts.submissionInLearningNote}</p>
                                    </div>}

                                {assessment.dueDate &&
                                    <div className={classes.SubmissionDetails}>
                                        <p className={classes.SubmissionText}>{texts.submissionDate} </p>
                                        <p className={classes.SubmissionDate}>{Moment(assessment.dueDate).format('DD.MM.YY')}</p>
                                    </div>}
                            </div>

                            {ActivityTypeEnum[assessment.activityType] === ActivityTypeEnum.Final && <div className={classes.AllStatus}>
                                <StatusInfo
                                    status={assessment.submission?.submissionStatus}
                                    submittedDate={assessment.submission?.submittedDate}
                                    assessmentDueDate={assessment.submission?.assessmentDueDate} />
                            </div>}

                        </div>

                        {!onlyView && !teacherMode &&
                            (assessment.submission?.submissionStatus === 'NotStarted' || assessment.submission?.submissionStatus === 'Started' || assessment.submission?.submissionStatus === 'Submitted' || assessment.submission?.submissionStatus === 'Rejected' || assessment.submission?.submissionStatus === 'Resubmitted') &&
                            <SubmitBtn
                                lessonParticipant={lessonParticipant}
                                assessmentId={assessment.id}
                                submissionId={assessment.submission?.id}
                                activityType={assessment.activityType}
                                studyGroupId={studyGroupId}
                                saveProjectCallback={saveProjectCallback}
                                setAssesmentStatus={setAssesmentStatus}
                                setShowReflection={setShowReflection}
                                setPopupAssessmentLesson={setPopupAssessmentLesson} />}

                    </div>


                    {assessment.description ? <div className={classes.ProjectContainer}>
                        <div className={classes.Line}></div>
                        <div>
                            <p className={classes.Title}>{texts.assessmentDescription}</p>
                            <p className={classes.DescriptionProject}>{assessment.description}</p>
                        </div>
                    </div> : ''}


                    {assessment.submission?.project &&
                        <>
                            <div className={classes.Line}></div>

                            <div className={classes.Project}>
                                <p className={classes.ProjectText}>{texts.project}</p>
                                <Project
                                    project={{ ...assessment.submission?.project, ide: { id: contentData.IdeId } }}
                                    descriptionDate={assessment.submission?.project?.updateDate}
                                    openProject={() => openProject(assessment.externalId, assessment.submission)}
                                    canChange={!teacherMode}
                                    changeProjectFunc={() => setShowDrafts(true)}
                                    noEditName={true}
                                    name={assessment.submission?.project?.name}
                                    updateDate={Moment(assessment.submission?.project?.updateDate).format('DD.MM.YY | HH:mm')}
                                    showFunc={true}
                                    shareBtn={shareBtn}
                                    onlyView={onlyView}
                                    saveProjectCallback={saveProjectCallback}
                                    canRestore={true}
                                    assessmentId={assessment.id}
                                    isDisabled={isDisabled}
                                />
                            </div>

                        </>}
                    {(assessment.submission?.submissionStatus !== "Completed" || (assessment?.submission?.contentData && (JSON.parse(assessment.submission.contentData)?.Attachments) && (JSON.parse(assessment.submission.contentData)?.Attachments).length > 0)) && (<div className={classes.UploadContainer}>
                        <div className={classes.Line}></div>

                        {assessment.submission?.submissionStatus !== "Completed" ? <div className={classes.UploadTitle}>{texts.attachFilesForSubmission}</div> : (assessment?.submission?.contentData && JSON.parse(assessment.submission.contentData)?.Attachments)?.length && <div className={classes.UploadTitle}>{texts.attachmentsForSubmission}</div>}
                        <div className={classes.Upload}>
                            {assessment.submission?.submissionStatus !== "Completed" && <div className={classes.UploadInput}>
                                <input className={classes.FileInput} onClick={(e) => e.target.value = ''} onChange={chooseFromDevice} type="file" id="FileInput" multiple />
                            </div>}
                            {assessment?.submission?.contentData && (JSON.parse(assessment.submission.contentData)?.Attachments)?.map((f, i) =>
                                <div className={classes.FileWrapper} key={i}>
                                    <div className={classes.FileName}>{f.Description}</div>
                                    {assessment.submission?.submissionStatus !== "Completed" && <div className={classes.DeleteWrapper}>
                                        <img className={classes.Delete} src={DeleteIcon} onClick={() => DeleteFile(f)} alt={texts.delete} />
                                    </div>}
                                </div>
                            )}
                        </div>
                    </div>)}


                    {contentData && contentData.Attachments && contentData.Attachments.length > 0 &&
                        <div className={classes.AuxiliaryMaterialsContainer}>

                            <div className={classes.Line}></div>

                            {/* <div> */}
                            <p className={classes.Title}>{texts.downloadAuxiliaryMaterials}</p>
                            {/* <p className={classes.AuxiliaryMaterialDescription}>{texts.auxiliaryMaterialsProjectContent}</p> */}
                            {/* </div> */}
                            <div className={classes.AuxiliaryMaterials}>{contentData.Attachments.map(a => {
                                const thumbnail = DynamicFileThumbnail(a.FileSubUrl, assessment.filesBaseUrl)
                                return <div className={classes.AuxiliaryMaterial} key={a.Id} onClick={() => setFilesPopup(<FilesPopup fileUrl={thumbnail} title={a.Description} setMessage={setFilesPopup} />)}>
                                    <img className={classes.AuxiliaryMaterialImg} src={thumbnail} alt={thumbnail} />
                                    <p className={classes.AuxiliaryMaterialText}>{a.Description}</p>
                                    <img className={classes.Download} src={DownloadIcon} alt="dawnloadIcon" onClick={(e) => { e.preventDefault(); e.stopPropagation(); downloadResource(a.FileSubUrl, a.Description) }} />
                                </div>
                            })}
                            </div>

                        </div>}
                    {filesPopup}

                    {showDrafts &&
                        <div className={classes.ProjectsWrapper}>
                            <div className={classes.Projects}>
                                <div className={classes.ProjectsTitle}>
                                    <div className={classes.ProjectsTitleText}>{texts.changeProjectToSubmit}</div>
                                    <div className={classes.Circle} onClick={closePopup}>
                                        <div className={classes.XLine}></div>
                                        <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                                    </div>
                                </div>
                                {ProjectsComm && <ProjectsComm isPopup={true} chosenProjectCallback={changeChosenProject} />}
                            </div>
                        </div>
                    }

                </div> :
                <div className={classes.NoAssessment}>{texts.noAssesments}</div>
            }
        </div >
    )
}

export default SingleLessonAssessment;

